import forEach from 'lodash/forEach';
import isEmpty from 'lodash/isEmpty';
import mapValues from 'lodash/mapValues';
import * as TimeInterval from '../TimeInterval';
/**
 * Merge two calendars. Does NOT fill the gaps
 */
export const merge = (a, b) => {
    if (isEmpty(a)) {
        return b;
    }
    if (isEmpty(b)) {
        return a;
    }
    const res = JSON.parse(JSON.stringify(a));
    forEach(b, (value, day) => {
        if (!res[day]) {
            res[day] = value;
            return;
        }
        res[day].schedule = TimeInterval.mergeNormalizedLists(res[day].schedule, value.schedule);
    });
    return res;
};
/**
 * Subtract all intervals from calendar `b` from calendar `a`
 * @param a Calendar to subtract from
 * @param b Calendar to subtract
 * @returns Calendar with intervals from a subtracted all from b
 */
export const subtract = (a, b) => {
    if (isEmpty(b)) {
        return a;
    }
    return mapValues(a, (value, key) => {
        if (!b[key]) {
            return value;
        }
        return {
            ...value,
            schedule: TimeInterval.subtractNormalizedLists(value.schedule, b[key].schedule),
        };
    });
};
//# sourceMappingURL=Calendar.js.map